export default __webpack_public_path__ + "static/media/swirl.3afdef7a.png";